import CommissionsRouteConstants from 'Agent/Commissions/CommissionsRouteConstants';
import {PoliciesApi} from 'Agent/Policies/api';
import {
  CorrespondenceDetailsApi,
  ImagesApi,
  PendingUnderwritingRequirementsApi,
  PolicyDto,
} from 'Agent/Policies/api/api';
import {CorrespondenceLetterSummary} from 'Agent/Policies/api/apiTypes';
import {PolicyFilter} from 'Agent/Policies/ducks/policy';
import {
  PolicyCorrespondenceDetailFilter,
} from 'Agent/Policies/ducks/policyCorrespondence';
import {AxiosResponse} from 'axios';
import {AsyncResult} from 'Core/models/Async';
import {Page} from 'Core/models/Page';
import {Sort, toSortQuerystringParams} from 'Shared/components/PagedView/Table/Sort';
import axiosInstance from 'Shared/utilities/axiosInstance';
import {getAxiosConfig, getUrlFromUri, handleResponse, withCancellation} from 'Shared/utilities/fetchHelpers';
import PolicyRouteConstants from '../PolicyRouteConstants';
import {PendingUnderwritingRequirementDto, PolicyApplicationDto } from './api';

const policiesApi = new PoliciesApi(undefined, process.env.REACT_APP_BASE_GATEWAY_URL, axiosInstance);
const correspondenceDetailsApi = new CorrespondenceDetailsApi(
  undefined,
  process.env.REACT_APP_BASE_GATEWAY_URL,
  axiosInstance
);
const imagesApi = new ImagesApi(undefined, process.env.REACT_APP_BASE_GATEWAY_URL, axiosInstance);
const pendingUnderwritingRequirementApi = new PendingUnderwritingRequirementsApi(
  undefined,
  process.env.REACT_APP_BASE_GATEWAY_URL,
  axiosInstance
);

export default {
  getImages: (encryptedIdentifier: string, policyId: string, eisFlag: boolean) =>
    imagesApi
      .getPolicyImageById(policyId, '1', {params: {encryptedIdentifier, eisFlag}, ...getAxiosConfig()})
      .then(handleResponse),
  getPolicy: (bodyParams: URLSearchParams) =>
    {const apiUrl = PolicyRouteConstants.POLICY_DETAILS_API('1');
    const axiosConfig = getAxiosConfig();
    return axiosInstance
            .post(getUrlFromUri(`${apiUrl}`), bodyParams , {
              ...axiosConfig,
              headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                ...axiosConfig.headers,
              },
            })
            .then(handleResponse) as Promise<AsyncResult<PolicyDto>>},
  getCorrespondenceSummaries: (
    bodyParams: URLSearchParams
  ) => {
    const apiUrl = CommissionsRouteConstants.COMMISSIONS_API('1');
    const axiosConfig = getAxiosConfig();
    return axiosInstance
            .post(getUrlFromUri(`${apiUrl}`), bodyParams , {
              ...axiosConfig,
              headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                ...axiosConfig.headers,
              },
            })
            .then(handleResponse) as Promise<AxiosResponse<Page<CorrespondenceLetterSummary>>>;
  },
  getCorrespondenceDetails: async (filter: PolicyCorrespondenceDetailFilter) => {
    const response = await correspondenceDetailsApi.getCorrespondenceDetails('1', {
      params: filter,
      ...getAxiosConfig(undefined, false),
    });
    return handleResponse(response);
  },
  searchPolicies: (
    agentNumbers: string[],
    isNewYork: boolean,
    encryptedIdentifier: string,
    filter?: PolicyFilter,
    sort?: Sort
  ) => {
    return (withCancellation(cancelToken =>
      policiesApi.searchPolicies('1', {
        params: {agentNumbers, isNewYork, encryptedIdentifier, ...filter, ...(sort && toSortQuerystringParams(sort))},
        ...getAxiosConfig(cancelToken, false),
      })
    ).then(handleResponse) as unknown) as Promise<AsyncResult<Page<PolicyDto>>>;
  },
  getPendingUnderwritingRequirements: async (
    encryptedIdentifier: string,
    agentNumbers: string[],
    isNewYork: boolean
  ) => {
    const response = await pendingUnderwritingRequirementApi.getPendingUnderwritingRequirements(
      '1',
      agentNumbers,
      isNewYork,
      false,
      {params: {encryptedIdentifier}, ...getAxiosConfig(undefined)}
    );

    return handleResponse(response as AxiosResponse<PendingUnderwritingRequirementDto[]>);
  },
  getPolicyApplications: (bodyParams: URLSearchParams) => {
    const apiUrl = PolicyRouteConstants.POLICY_APPLICATIONS_API('2');
            const axiosConfig = getAxiosConfig();
            return axiosInstance
              .post(getUrlFromUri(`${apiUrl}`), bodyParams , {
                ...axiosConfig,
                headers: {
                  'Content-Type': 'application/x-www-form-urlencoded',
                  ...axiosConfig.headers,
                },
              })
              .then(handleResponse) as Promise<AsyncResult<Page<PolicyApplicationDto>>>;
  },
  uploadPolicyDocument: async (
    encryptedIdentifier: string,
    file: File,
    policyUploadDocumentId: string,
    policyId: string,
    policyNumber: string,
    eisFlag: boolean | null
  ) => {
    const id = eisFlag ? policyNumber : policyId;

    const axiosConfig = getAxiosConfig();
    const apiURL = `api/policies/v1/${encodeURIComponent(id)}/document/upload`;
    const policyUploadDocumentFormData = new FormData();
    policyUploadDocumentFormData.append('PolicyNumber', policyNumber as any);
    policyUploadDocumentFormData.append('PolicyUploadDocumentId', Number(policyUploadDocumentId) as any);
    policyUploadDocumentFormData.append('File', file);
    policyUploadDocumentFormData.append('eisFlag', eisFlag as any);
    policyUploadDocumentFormData.append('policyId', policyId);
    const response = await axiosInstance.post(apiURL, policyUploadDocumentFormData, {
      headers: {
        ...axiosConfig.headers,
        'Content-Type': 'multipart/form-data',
      },
      params: {
        encryptedIdentifier,
      },
    });
    return handleResponse(response);
  },
};
